import * as React from 'react';
import { GameProvider } from './GameContext';
import Game, { Props } from './Game';

const MatchGame: React.FC<Props> = ({ data, id }) => {
  return (
    <GameProvider>
      <Game data={data} id={id} />
    </GameProvider>
  );
};

export default MatchGame;
